import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { PostEscalationCurationActions } from './post-escalation-curation.actions';
import { LiveChatActions } from '../live-chat/live-chat.actions';
import { MessagesActions } from '../messages/messages.actions';

@Injectable({
  providedIn: 'root',
})
export class PostEscalationCurationEffects {
  constructor(private actions$: Actions) {}

  addPostEscalationMessageSelection$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostEscalationCurationActions.updateSelectedItems),
      switchMap((action) => {
        const departmentId = action.value.departmentId;
        const platform = action.value.platform;
        const aaEligible = action.value.aaEligible;
        return of(
          MessagesActions.addPostEscalationMessageSelection({
            postEscalationSelection: action.value,
          }),
          LiveChatActions.escalateToLiveChat({
            departmentId,
            platform,
            aaEligible,
          })
        );
      })
    )
  );
}
